"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _classnames = _interopRequireDefault(require("classnames"));

var _sizes = require("HubStyleTokens/sizes");

var _times = require("HubStyleTokens/times");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Functions = require("../core/Functions");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _UILink = _interopRequireDefault(require("../link/UILink"));

var _PlacementConstants = require("../tooltip/PlacementConstants");

var _UITooltip = _interopRequireDefault(require("../tooltip/UITooltip"));

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

var _decorators = require("../utils/propTypes/decorators");

var _iconName = require("../utils/propTypes/iconName");

var _Styles = require("../utils/Styles");

var _TabConstants = require("./TabConstants");

var _tabUtils = require("./utils/tabUtils");

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n            text-align: center;\n            width: 100%;\n          "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  /*\n    TODO: remove specificity bump when UILink is converted to styled-components\n    Previous styling was still at a 2-level specificity so this should be fine\n  */\n  && {\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n\n    color: ", ";\n    position: relative;\n\n    /*\n      Fix issue where a \"contained\" tab's short-hand transition stylings on background would\n      override the color transition.\n    */\n    transition-property: ", ";\n    white-space: nowrap;\n\n    &:focus {\n      text-decoration: none;\n      z-index: ", ";\n    }\n\n    ", ";\n    ", ";\n\n    ", ";\n\n    ", ";\n\n    &.sr-only-focusable {\n      align-items: center;\n      display: inline-flex;\n    }\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n              border-bottom-color: ", ";\n\n              &::after {\n                background: ", " !important;\n                bottom: -1px;\n                content: ' ';\n                height: 1px;\n                left: 0;\n                position: absolute;\n                width: 100%;\n              }\n            "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        transition: background-color ", "\n          cubic-bezier(0.25, 0.1, 0.25, 1);\n        background-color: ", ";\n        border-left: 1px solid ", ";\n\n        &:first-child {\n          border-left: 0;\n          border-top-left-radius: inherit;\n        }\n\n        &:last-of-type {\n          border-top-right-radius: inherit;\n        }\n\n        ", " {\n          display: none;\n        }\n\n        ", ";\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        cursor: not-allowed;\n        ", " {\n          color: ", ";\n        }\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        &:hover {\n          color: ", ";\n        }\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        ", ";\n        &:hover {\n          ", ";\n        }\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  /*\n    TODO: this gets overridden by a different selector (except active),\n    but has same styles - is it still needed?\n  */\n  &&&& {\n    color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n  background-color: currentColor;\n  border-radius: 24px;\n  bottom: ", ";\n  height: ", ";\n  left: 0;\n  opacity: ", ";\n  position: absolute;\n  width: 100%;\n  z-index: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var TabIndicator = _styledComponents.default.span.withConfig({
  displayName: "UITab__TabIndicator",
  componentId: "sc-1ih9kho-0"
})(_templateObject(), (0, _Styles.setUiTransition)(), (0, _Styles.toPx)(parseInt(_sizes.TAB_INDICATOR_HEIGHT, 10) / 2 * -1), _sizes.TAB_INDICATOR_HEIGHT, function (_ref) {
  var tabIsActive = _ref.tabIsActive;
  return tabIsActive ? '1 !important' : '0';
}, function (_ref2) {
  var tabIsActive = _ref2.tabIsActive;
  return tabIsActive ? _sizes.MERCURY_LAYER : null;
});

var TabIcon = (0, _styledComponents.default)(function (props) {
  var __tabIsActive = props.tabIsActive,
      rest = (0, _objectWithoutProperties2.default)(props, ["tabIsActive"]);
  return _react.default.createElement(_UIIcon.default, rest);
}).withConfig({
  displayName: "UITab__TabIcon",
  componentId: "sc-1ih9kho-1"
})(_templateObject2(), function (_ref3) {
  var tabIsActive = _ref3.tabIsActive;
  return tabIsActive ? 'currentColor' : null;
});
TabIcon.displayName = 'StyledTabIcon';

var handleFontFamily = function handleFontFamily(isActive) {
  return isActive ? (0, _styledComponents.css)(_templateObject3(), _Styles.FONT_FAMILIES.medium, _Styles.FONT_FAMILIES.medium) : _Styles.FONT_FAMILIES.default;
};

var handleHoverColor = function handleHoverColor(isActive) {
  return !isActive ? (0, _styledComponents.css)(_templateObject4(), _TabConstants.FOREGROUND_FOCUS_COLOR) : null;
};

var handleDisabledOnlyStyles = function handleDisabledOnlyStyles(isDisabled) {
  return isDisabled ? (0, _styledComponents.css)(_templateObject5(), TabIcon, _TabConstants.DISABLED_COLOR) : null;
};

var getBackgroundColor = function getBackgroundColor(use, active) {
  if (active) {
    return (0, _tabUtils.getSelectedTabBackgroundColor)(use);
  }

  return use === 'enclosed-shaded' ? _TabConstants.ENCLOSED_SHADED_BACKGROUND_COLOR : _TabConstants.ENCLOSED_BACKGROUND_COLOR;
};

var handleContainedStyles = function handleContainedStyles(use, active) {
  return (0, _tabUtils.isContained)(use) ? (0, _styledComponents.css)(_templateObject6(), _times.TABS_ACTIVATE_TRANSITION_TIMING, getBackgroundColor(use, active), _TabConstants.BORDER_COLOR, TabIndicator, active ? (0, _styledComponents.css)(_templateObject7(), (0, _tabUtils.getSelectedTabBackgroundColor)(use), (0, _tabUtils.getSelectedTabBackgroundColor)(use)) : null) : null;
};

var StyledLink = (0, _styledComponents.default)(function (props) {
  var __active = props.active,
      __fill = props.fill,
      __use = props.use,
      rest = (0, _objectWithoutProperties2.default)(props, ["active", "fill", "use"]);
  return _react.default.createElement(_UILink.default, (0, _extends2.default)({
    use: "unstyled"
  }, rest));
}).withConfig({
  displayName: "UITab__StyledLink",
  componentId: "sc-1ih9kho-2"
})(_templateObject8(), (0, _Styles.setFontSmoothing)('auto'), function (_ref4) {
  var active = _ref4.active;
  return handleFontFamily(active);
}, (0, _Styles.setFontSize)(_sizes.TAB_FONT_SIZE), (0, _Styles.setInputMetrics)(_sizes.TAB_PADDING_Y, _sizes.TAB_PADDING_X, _sizes.TAB_PADDING_X, _sizes.TAB_PADDING_Y, false), function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? _TabConstants.DISABLED_COLOR + " !important" : _TabConstants.FOREGROUND_COLOR;
}, function (_ref6) {
  var use = _ref6.use;
  return (0, _tabUtils.isContained)(use) ? 'background-color, color' : 'color';
}, _sizes.MERCURY_LAYER, function (_ref7) {
  var active = _ref7.active;
  return handleHoverColor(active);
}, function (_ref8) {
  var disabled = _ref8.disabled;
  return handleDisabledOnlyStyles(disabled);
}, function (_ref9) {
  var fill = _ref9.fill;
  return fill ? (0, _styledComponents.css)(_templateObject9()) : null;
}, function (_ref10) {
  var use = _ref10.use,
      active = _ref10.active;
  return handleContainedStyles(use, active);
});

var UITab =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UITab, _PureComponent);

  function UITab() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UITab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UITab)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleClick = function (evt) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          tabId = _this$props.tabId;
      (0, _Functions.callIfPossible)(onClick, (0, _SyntheticEvent.default)(tabId, evt));
    };

    return _this;
  }

  (0, _createClass2.default)(UITab, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          active = _this$props2.active,
          className = _this$props2.className,
          icon = _this$props2.icon,
          Link = _this$props2.Link,
          __onClick = _this$props2.onClick,
          title = _this$props2.title,
          tabId = _this$props2.tabId,
          tooltip = _this$props2.tooltip,
          tooltipPlacement = _this$props2.tooltipPlacement,
          tooltipProps = _this$props2.tooltipProps,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["active", "className", "icon", "Link", "onClick", "title", "tabId", "tooltip", "tooltipPlacement", "tooltipProps"]);

      var renderedTabContents = _react.default.createElement(Link, (0, _extends2.default)({}, rest, {
        active: active,
        className: (0, _classnames.default)(className, 'private-tab', {
          'private-tab--active': active
        }),
        "data-tab-id": tabId,
        "data-tab-selected": active,
        onClick: this.handleClick
      }), icon ? _react.default.createElement(TabIcon, {
        tabIsActive: active,
        className: "private-tab__icon",
        name: icon,
        size: "xxs"
      }) : null, title, _react.default.createElement(TabIndicator, {
        tabIsActive: active,
        className: "private-tab__indicator"
      }));

      if (!tooltip) return renderedTabContents;
      return _react.default.createElement(_UITooltip.default, (0, _extends2.default)({
        placement: tooltipPlacement,
        title: tooltip
      }, tooltipProps), renderedTabContents);
    }
  }]);
  return UITab;
}(_react.PureComponent);

exports.default = UITab;
UITab.displayName = 'UITab';
UITab.propTypes = {
  active: _propTypes.default.bool,
  href: _UILink.default.propTypes.href,
  icon: (0, _iconName.getIconNamePropType)(),
  Link: (0, _decorators.hidden)(_component.default.isRequired),
  tabId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
  title: _propTypes.default.node.isRequired,
  tooltip: _propTypes.default.node,
  tooltipProps: _propTypes.default.object,
  tooltipPlacement: _propTypes.default.oneOf(_PlacementConstants.PLACEMENTS)
};
UITab.defaultProps = {
  Link: StyledLink,
  onClick: _emptyFunction.default
};
module.exports = exports.default;